import { BookingEntity } from 'Models/Entities';
import {
	fetchBookingForBookingDetailedView,
	fetchBookingForBookingDetailedViewByQrCodeId,
} from 'Services/Api/_HumanWritten/BookingService/FerryTripBookingService';
import { FetchEventBookingForBookingDetailedView } from '../Api/_HumanWritten/BookingService/EventsBookingService';
import { isAxiosError } from 'axios';
import alertToast from 'Util/ToastifyUtils';

// See serverside\src\Utility\ExpressionUtilities.cs for more info for how the paths are used.

export async function getBookingForBookingDetailedView(
	bookingId: string,
	userId: string | null = null,
): Promise<BookingEntity | undefined> {
	try {
		const booking = await fetchBookingForBookingDetailedView(bookingId, userId);
		if (booking == null) {
			return undefined;
		}

		return new BookingEntity(booking);
	} catch (e) {
		if (isAxiosError(e)) {
			if (e.response?.status === 403) {
				alertToast("You don't have access to this booking.", 'error');
			}
		}
		console.error('Something went wrong while fetching the booking.');
	}
	return undefined;
}

export async function getBookingForScanner(
	qrCodeId: string,
	userId: string | null = null,
): Promise<BookingEntity | undefined> {
	try {
		const booking = await fetchBookingForBookingDetailedViewByQrCodeId(qrCodeId, userId);
		if (booking == null) {
			return undefined;
		}

		return new BookingEntity(booking);
	} catch (e) {
		if (isAxiosError(e)) {
			if (e.response?.status === 403) {
				alertToast("You don't have access to this booking.", 'error');
			}
		}
		console.error('Something went wrong while fetching the booking.');
	}
	return undefined;
}

export async function getEventBookingForBookingDetailedView(
	bookingId: string,
	userId: string | null = null,
): Promise<BookingEntity | undefined> {
	try {
		const booking = await FetchEventBookingForBookingDetailedView(bookingId, userId);
		if (booking == null) {
			return undefined;
		}

		return new BookingEntity(booking);
	} catch (e) {
		console.error('Something went wrong while fetching the event booking.');
	}

	return undefined;
}
